import { Box, Button, Flex } from "@chakra-ui/core"
import React from "react"
import { useDispatch, useSelector } from "react-redux"
import useGoogleAnalytics from "../../components/GoogleAnalytics/hooks/useGoogleAnalytics"
import useLoginDrawer from "../../context/loginDrawer"
import { BaseDispatch, BaseRootState } from "../../redux/store"
import { isValidUserLoggedIn } from "../../utils/auth"
import { bp } from "../../utils/MediaQueries"
import Body from "../typography/Body"

type InitialQuizScreenProps = {
  quizIntroText?: React.ReactNode
}

const InitialQuizScreen: React.FC<InitialQuizScreenProps> = () => {
  const dispatch = useDispatch<BaseDispatch>()
  const { accessToken, tokenExpiration } = useSelector(
    (state: BaseRootState) => ({
      tokenExpiration: state.user.tokenExpiration,
      accessToken: state.user.accessToken,
      quizProgressState: state.quiz.quizProgressState,
      previousQuizAnswers: state.quiz.previousQuizAnswers,
    })
  )
  const { openLoginDrawer } = useLoginDrawer()
  const isLoggedIn = isValidUserLoggedIn({ accessToken, tokenExpiration })
  // Started Quiz Event
  const googleAnalytics = useGoogleAnalytics({
    category: "Body Fit",
    action: "click",
    shouldFireOnFirstRender: false,
  })

  // Sidebar State
  const {
    sidebar: { isOpen: sidebarOpen },
  } = useSelector((state: BaseRootState) => state)

  return (
    <Flex
      className=""
      display="flex"
      flexDirection="column"
      bg="primary"
      h="100%"
      p={bp("1.5rem", "2rem")}
      alignItems="center"
      justifyContent="space-between"
      background="transparent"
      borderRadius="20px"
      // style={{
      //   backgroundColor: "transparent !important",
      //   backgroundImage: `url(${bgImage})`,
      //   backgroundSize: "cover",
      //   backgroundRepeat: "no-repeat",
      //   backgroundPosition: "center",
      // }}
    >
      <Flex w="100%" h="100%" flexDirection="row">
        <Flex w={bp("43%", "45%")} className="blank-section"></Flex>
        <Box w={bp("57%", "55%")} className="text-section" as="div">
          <Flex
            className="QuizMobileHeaderText"
            justifyContent="space-between"
            flexDirection="column"
            style={{ gap: "15px" }}
          >
            <Body
              as="h3"
              className="QuizInitHeading"
              fontSize={bp("2rem", "2.3rem")}
              lineHeight={bp("2rem", "2.3rem")}
              fontWeight={900}
              color="#ffffff"
            >
              Find Your
              <br />
              Perfect
              <br />
              Match
            </Body>

            <Button
              className="startFittingBtn"
              bg="white"
              borderRadius="20px"
              color="#005f78"
              w="fit-content"
              h={bp("2rem", "2.5rem")}
              p={bp("0 1.3rem", "0 1.7rem")}
              boxShadow="0px 0.625rem 1.875rem rgba(0, 196, 209, 0.2)"
              fontFamily="din"
              fontWeight="bold"
              fontSize={bp("0.675rem", "0.875rem")}
              lineHeight="1.0625rem"
              letterSpacing="1px"
              textTransform="uppercase"
              onClick={() => {
                dispatch.quiz.setProgressState("inprogress")
                dispatch.quiz.setQuizStartTime(Date.now().toString())
                googleAnalytics.fireEvent()
                sidebarOpen ? dispatch.sidebar.toggleOpen() : ""
              }}
            >
              Start Fitting
            </Button>

            <Body
              className="QuizMobileHeaderSubHeading"
              color="#9eb3bc"
              fontWeight={500}
              style={{ textAlign: "left" }}
              fontSize={bp("0.8rem", "1rem")}
            >
              Get Fitted In Under 2 Minutes
            </Body>
          </Flex>
        </Box>
      </Flex>
    </Flex>
  )
}

export default InitialQuizScreen
